"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusEnvioMensagemEnum = exports.TipoEnvioMensagemEnum = exports.TipoParametroEnum = exports.TipoRelatorioEnum = exports.TipoSaidaRelatorioEnum = void 0;
var TipoSaidaRelatorioEnum;
(function (TipoSaidaRelatorioEnum) {
    TipoSaidaRelatorioEnum["PDF"] = "pdf";
    TipoSaidaRelatorioEnum["CSV"] = "csv";
})(TipoSaidaRelatorioEnum = exports.TipoSaidaRelatorioEnum || (exports.TipoSaidaRelatorioEnum = {}));
var TipoRelatorioEnum;
(function (TipoRelatorioEnum) {
    TipoRelatorioEnum["ANALITICO"] = "A";
    TipoRelatorioEnum["SINTETICO"] = "S";
    TipoRelatorioEnum["GERENCIAL"] = "G";
})(TipoRelatorioEnum = exports.TipoRelatorioEnum || (exports.TipoRelatorioEnum = {}));
var TipoParametroEnum;
(function (TipoParametroEnum) {
    TipoParametroEnum["TEXTO"] = "texto";
    TipoParametroEnum["NUMERO"] = "numero";
    TipoParametroEnum["VALOR_MONETARIO"] = "valor_monetario";
    TipoParametroEnum["BOOLEAN"] = "boolean";
    TipoParametroEnum["LISTA"] = "lista";
    TipoParametroEnum["VALOR_CRIPTOGRAFADO"] = "valor_criptografado";
})(TipoParametroEnum = exports.TipoParametroEnum || (exports.TipoParametroEnum = {}));
var TipoEnvioMensagemEnum;
(function (TipoEnvioMensagemEnum) {
    TipoEnvioMensagemEnum["EMAIL"] = "E";
    TipoEnvioMensagemEnum["WHATSAPP"] = "Z";
})(TipoEnvioMensagemEnum = exports.TipoEnvioMensagemEnum || (exports.TipoEnvioMensagemEnum = {}));
var StatusEnvioMensagemEnum;
(function (StatusEnvioMensagemEnum) {
    StatusEnvioMensagemEnum["SUCESSO"] = "S";
    StatusEnvioMensagemEnum["ERRO"] = "E";
    StatusEnvioMensagemEnum["PENDENTE"] = "P";
    StatusEnvioMensagemEnum["NAO_SE_APLICA"] = "N";
})(StatusEnvioMensagemEnum = exports.StatusEnvioMensagemEnum || (exports.StatusEnvioMensagemEnum = {}));
